var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.23 47.38H36.77V59.3h16.46V47.38z",
    fill: "#486688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.95 6.75h-47.9a6.68 6.68 0 0 0-6.68 6.68v28.8a6.68 6.68 0 0 0 6.68 6.68h47.9a6.68 6.68 0 0 0 6.68-6.68v-28.8a6.68 6.68 0 0 0-6.68-6.68z",
    fill: "#B3ACA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.58 6.75H23.42a6.35 6.35 0 0 0-6.35 6.35v29.46a6.35 6.35 0 0 0 6.35 6.35h43.16a6.35 6.35 0 0 0 6.35-6.35V13.1a6.35 6.35 0 0 0-6.35-6.35z",
    fill: "#E8E6E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.72 11.4H23.08a1.98 1.98 0 0 0-1.98 1.98v28.36a1.98 1.98 0 0 0 1.98 1.98h44.64a1.98 1.98 0 0 0 1.98-1.98V13.38a1.98 1.98 0 0 0-1.98-1.98z",
    fill: "#749BBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83.25c12.07 0 22.95-5.08 30.63-13.22v-5.47a6.68 6.68 0 0 0-6.68-6.68h-47.9a6.68 6.68 0 0 0-6.68 6.68v5.47C22.05 78.16 32.93 83.25 45 83.25z",
    fill: "#B3ACA8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.57 57.88H23.43c-3.51 0-6.35 2.84-6.35 6.35v8.42c7.44 6.59 17.21 10.59 27.93 10.59 10.72 0 20.49-4.01 27.93-10.59v-8.42c0-3.51-2.84-6.35-6.35-6.35h-.02z",
    fill: "#E8E6E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.63 68.23c.24-1.77.23-3.51 0-5.17-.18-1.32-1.36-2.27-2.69-2.27H24.27c-2.09 0-3.78 1.69-3.78 3.78v4.59c0 1.18.6 2.27 1.58 2.93 8.12 5.52 16.18 6.76 19.39 7.04.93.08 1.85-.3 2.45-1.02 2.29-2.73 4.25-6.38 4.73-9.89l-.01.01z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.63 19.02h6.43c1.62 0 2.93 1.32 2.93 2.93V34.4c0 1.62-1.32 2.93-2.93 2.93h-6.43V19.01v.01zM14.37 37.33H7.94c-1.62 0-2.93-1.32-2.93-2.93V21.95c0-1.62 1.32-2.93 2.93-2.93h6.43v18.32-.01z",
    fill: "#486688"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13.44a2.67 2.67 0 0 0-1.52-2.04h-21.4c-.1 0-.2.02-.3.03a2 2 0 0 0-1.69 1.95v20.3c.42.51 1.02.86 1.71.93 1.72.19 6.14.14 7.98-.19 7.93-1.43 14.13-7.87 15.22-15.85.24-1.76.23-3.47 0-5.12v-.01z",
    fill: "#AED0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer..0b4771ddb712cb198f392751724a8922.svg";
export { ForwardRef as ReactComponent };